import React, { Component } from 'react';
//Dashboards
import RootDashboard from './Components/RootDashboard';
import HVendTechnicanDashboard from './Components/HVendTechnicanDashboard';
// import AdminDashboard from './Components/AdminDashboard';
import CustomerDashboard from './Components/CustomerDashboard';
import TechnicanDashboard from './Components/TechnicanDashboard';
// import OperatorDashboard from './Components/OperatorDashboard';

import { connect } from 'react-redux';

import UserUtil from '../../services/util/userUtil';

const mapStateToProps = state => ({
	user: state.user
});

class Dashboard extends Component {
	//GET DASHBOARD ELEMENT
	getDashboardElement() {
		const { user } = this.props;
		console.log('Dashboard - User data:', user);
		console.log('Dashboard - UserUtil checks:', {
			isRoot: UserUtil.isRoot(),
			isHVendTechnican: UserUtil.isHVendTechnican(),
			isAdministrator: UserUtil.isAdministrator(),
			isRegionalCompanyAdmin: UserUtil.isRegionalCompanyAdmin(),
			isTechnican: UserUtil.isTechnican()
		});

		switch (true) {
			case UserUtil.isRoot():
				console.log('Loading RootDashboard');
				return <RootDashboard />;
			case UserUtil.isHVendTechnican():
				console.log('Loading HVendTechnicanDashboard');
				return <HVendTechnicanDashboard />;
			case UserUtil.isAdministrator() || UserUtil.isRegionalCompanyAdmin():
				console.log('Loading CustomerDashboard');
				return <CustomerDashboard />;
			case UserUtil.isTechnican():
				console.log('Loading TechnicanDashboard');
				return <TechnicanDashboard />;
			//	case UserUtil.isBusinessAnalyst():
			//		return <OperatorDashboard />;
			default:
				console.log('No dashboard match - returning fallback CustomerDashboard');
				return <CustomerDashboard />;
		}
	}

	render() {
		return <div>{this.getDashboardElement()}</div>;
	}
}

export default connect(mapStateToProps)(Dashboard);
